import React, { useEffect } from 'react';
import isClient from '../../common/helpers/environment';

export const useUniversalEffect = (effect: React.EffectCallback, deps?: any[] | undefined) => {
    if (!isClient()) {
        const cleanup = effect();
        if (cleanup) {
            cleanup();
        }
    }
    useEffect(effect, deps);
};

export default { useUniversalEffect };
